import React, { useEffect } from "react";
import Navbar from "../Components/Navbar";
import "react-tabs/style/react-tabs.css";
import Footer from "../Components/Footer";
import initializeAOS from "../utils/aosLibrary";
import line_vector from "../assets/line3-vector.svg";
import arrow_new from "../assets/Arrow_service.svg";
import work1 from "../assets/Analysis - Research.png";
import work2 from "../assets/Proof - Concept (1).png";
import work3 from "../assets/Execution - Test.png";
import work4 from "../assets/Launch the Product (1).png";
import IT_image3 from "../assets/IT Staffing_3.png";
import IT_image1 from "../assets/IT Staffing_1.png";
import EnouthTalk from "../Components/EnouthTalk";
import { useMediaQuery } from "@mui/material";
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';

function AboutUs() {
  const isXs = useMediaQuery("(min-width:600px) and (max-width:3000px)");
  const { t } = useTranslation();
  useEffect(() => {
    document.title =
      "About Us | Fundest – Expert IT Services & Cloud Solutions";
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Discover Fundest, a leading provider of tailored IT services and cloud solutions, is committed to empowering businesses with innovative technology and expert support."
    );
    initializeAOS();
  }, []);

  const fontLivic = "Livvic , sans-serif";

  return (
    <>
      <Navbar />
      <Helmet>
        <title>About Us - Our Company</title>
        <meta
          name="description"
          content="Learn more about our company, mission, values, and team."
        />
      </Helmet>
      <div
        style={{
          height: "300px",
          background:
            "linear-gradient(105deg, rgba(244, 236, 194, .6) 1.74%, rgba(228, 250, 242, .6) 39.85%, rgba(211, 243, 207, .6) 73.94%, rgba(255, 243, 228, .6) 98.01%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          <h1
            data-aos="fade-up"
            style={{
              fontSize: isXs ? "64px" : "50px",
              lineHeight: "1.15",
              letterSpacing: "0.67px",
              fontWeight: "bold",
              fontWeight: "700",
            }}
          >
            {t('navbar.menus', { returnObjects: true })[1]['name']}
          </h1>
        </div>
        <div
          data-aos="fade-up"
          data-aos-duration="3000"
          style={{
            color: "black",
            fontFamily: fontLivic,
            fontSize: "18px",
            textAlign: "center",
            width: "80%",
            maxWidth: "500px"
          }}
        >
          {t('aboutUs.headline')}
        </div>
        <img
          src={arrow_new}
          loading="lazy"
          alt="Hero Shape Image"
          className="hero-shape-2"
          style={{
            display: isXs ? "flex" : "none",
            animation: "moveUpDown 1.5s infinite alternate",
            position: "absolute",
            top: "180px",
            left: "87px",
            zIndex: "5",
          }}
        />
        <img
          style={{
            position: "absolute",
            right: "0",
            top: "200px",
            display: isXs ? "flex" : "none",
          }}
          src={line_vector}
          alt=""
        />
      </div>

      <div
        style={{
          display: "flex",
          padding: isXs ? "0px 60px" : "30px 30px",
          paddingTop: "90px",
          flexDirection: isXs ? "row" : "column",
        }}
      >
        <div data-aos="fade-right" style={{ width: "50%" }}>
          <div
            style={{
              width: isXs ? "610px" : "350px",
              height: isXs ? "400px" : "350px",
            }}
          >
            <img
              style={{
                borderRadius: "30px",
                objectFit: "cover",
                height: "100%",
                width: "100%",
              }}
              src={IT_image3}
              alt=""
            />{" "}
          </div>
        </div>
        <div
          data-aos="fade-left"
          style={{
            width: isXs ? "50%" : "100%",
            display: "flex",
            flexDirection: "column",
            gap: "30px",
            paddingTop: isXs ? "" : "50px",
            paddingRight: isXs ? "60px" : "",
          }}
        >
          <div style={{ fontFamily: fontLivic, letterSpacing: "1px" }}>
            {t('aboutUs.paragraph_1')}
          </div>
          <div style={{ fontFamily: fontLivic, letterSpacing: "1px" }}>
            {t('aboutUs.paragraph_2')}
          </div>
          <div style={{ fontFamily: fontLivic, letterSpacing: "1px" }}>
            {t('aboutUs.paragraph_3')}
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          padding: isXs ? "90px 60px" : "90px 30px",
          flexDirection: isXs ? "row" : "column",
        }}
      >
        <div style={{ width: isXs ? "50%" : "100%" }}>
          <div class="container" style={{ padding: "0px" }}>
            <ul
              data-aos="fade-up"
              class="nav nav-tabs"
              id="myTab"
              role="tablist"
            >
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link active"
                  id="home-tab"
                  data-bs-toggle="tab"
                  href="#home"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                >
                  {t('aboutUs.tab_1.heading')}
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link"
                  id="profile-tab"
                  data-bs-toggle="tab"
                  href="#profile"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                >
                  {t('aboutUs.tab_2.heading')}
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link"
                  id="contact-tab"
                  data-bs-toggle="tab"
                  href="#contact"
                  role="tab"
                  aria-controls="contact"
                  aria-selected="false"
                >
                  {t('aboutUs.tab_3.heading')}
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <ul
                  style={{
                    display: "flex",
                    gap: "15px",
                    flexDirection: "column",
                    paddingLeft: "20px",
                    marginTop: "20px",
                    paddingRight: "40px",
                  }}
                >
                  <div
                    data-aos="fade-up"
                    style={{ fontSize: "18px", fontFamily: fontLivic }}
                  >
                    {t('aboutUs.tab_1.description')}
                  </div>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[0]['heading']}
                        {" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[0]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[1]['heading']}
                        {" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[1]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[2]['heading']}
                        {" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[2]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[3]['heading']}
                        {" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[3]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[4]['heading']}
                        {" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[4]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[5]['heading']}
                        {" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[5]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[6]['heading']}
                        {" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_1.tab_list', { returnObjects: true })[6]['short_description']}
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
              <div
                class="tab-pane fade"
                id="profile"
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                <ul
                  style={{
                    display: "flex",
                    gap: "15px",
                    flexDirection: "column",
                    paddingLeft: "20px",
                    marginTop: "20px",
                    paddingRight: "40px",
                  }}
                >
                  <div
                    data-aos="fade-up"
                    style={{ fontSize: "18px", fontFamily: fontLivic }}
                  >
                    {t('aboutUs.tab_2.description')}
                  </div>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_2.tab_list', { returnObjects: true })[0]['heading']}{" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_2.tab_list', { returnObjects: true })[0]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_2.tab_list', { returnObjects: true })[1]['heading']}{" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_2.tab_list', { returnObjects: true })[1]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_2.tab_list', { returnObjects: true })[2]['heading']}{" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_2.tab_list', { returnObjects: true })[2]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_2.tab_list', { returnObjects: true })[3]['heading']}{" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_2.tab_list', { returnObjects: true })[3]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_2.tab_list', { returnObjects: true })[4]['heading']}{" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_2.tab_list', { returnObjects: true })[4]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_2.tab_list', { returnObjects: true })[5]['heading']}{" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_2.tab_list', { returnObjects: true })[5]['short_description']}
                      </span>
                    </div>
                  </li>
                </ul>{" "}
              </div>
              <div
                class="tab-pane fade"
                id="contact"
                role="tabpanel"
                aria-labelledby="contact-tab"
              >
                <ul
                  style={{
                    display: "flex",
                    gap: "15px",
                    flexDirection: "column",
                    paddingLeft: "20px",
                    marginTop: "20px",
                    paddingRight: "40px",
                  }}
                >
                  <div
                    data-aos="fade-up"
                    style={{ fontSize: "18px", fontFamily: fontLivic }}
                  >
                    {t('aboutUs.tab_3.description')}
                  </div>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[0]['heading']}{" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[0]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[1]['heading']}{" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[1]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[2]['heading']}{" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[2]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[3]['heading']}{" "}
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[3]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[4]['heading']}{" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[4]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[5]['heading']}{" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[5]['short_description']}
                      </span>
                    </div>
                  </li>
                  <li data-aos="fade-up">
                    <div>
                      {" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "600",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[6]['heading']}{" "}:
                      </span>{" "}
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: fontLivic,
                          letterSpacing: "0.67",
                          color: "#4A4A4A",
                        }}
                      >
                        {t('aboutUs.tab_3.tab_list', { returnObjects: true })[6]['short_description']}
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div
          data-aos="fade-left"
          style={{
            width: isXs ? "50%" : "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: isXs ? "570px" : "300px",
              height: isXs ? "436px" : "300px",
            }}
          >
            <img
              style={{
                // marginTop: isXs ? "100px" : "50px",
                borderRadius: "50px 30px 30px 60px",
                // paddingLeft: "20px",
                objectFit: "cover",
                height: "100%",
                width: "100%",
              }}
              src={IT_image1}
              alt=""
            />
          </div>
        </div>
      </div>

      <div
        style={{
          padding: isXs ? "90px 60px" : "90px 30px",
          height: isXs ? "700px" : "1200px",
          backgroundImage:
            "linear-gradient(105deg, rgba(244, 236, 194, .2) 1.74%, rgba(228, 250, 242, .2) 39.85%, rgba(211, 243, 207, .2) 73.94%, rgba(255, 243, 228, .2) 98.01%)",
        }}
      >
        <div style={{ padding: "0px 0px 40px 0px" }}>
          <div
            data-aos="fade-up"
            style={{
              backgroundColor: "#F1F1F1",
              borderRadius: "25px",
              minWidth: "180px",
              width: "fit-content",
              maxWidth: "250px",
              padding: "10px 20px",
              fontSize: "18px",
              textAlign: "center",
              fontWeight: "400",
              color: "black",
            }}
          >
            {t('aboutUs.button')}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            marginBottom: "50px",
            flexDirection: isXs ? "row" : "column",
          }}
        >
          <div
            data-aos="fade-up"
            style={{
              width: isXs ? "50%" : "100%",
              marginBottom: "20px",
              display: "flex",
              gap: "30px",
              flexDirection: "column",
            }}
          >
            {" "}
            <h2 style={{ fontSize: "48px", fontWeight: "600", margin: "0px" }}>
              {t('aboutUs.paragraph_4')}
            </h2>
            <div
              data-aos="fade-up"
              style={{ fontFamily: fontLivic, letterSpacing: "1px" }}
            >
              {t('aboutUs.paragraph_5')}
            </div>
            <div
              data-aos="fade-up"
              style={{ fontFamily: fontLivic, letterSpacing: "1px" }}
            >
              {t('aboutUs.paragraph_6')}
            </div>
          </div>
          <div>
            <div
              data-aos="fade-up"
              style={{
                marginLeft: isXs ? "240px" : "0px",
                marginBottom: "40px",
                borderRadius: "60px",
                width: isXs ? "370px" : "auto",
                paddingLeft: "40px",
                alignItems: "center",
                gap: "10px",
                padding: isXs ? "20px 44px 20px 32px" : "20px 30px",
                display: "flex",
                position: "relative",
                boxShadow: "4px 0 15px rgba(0, 0, 0, 0.1)",
              }}
            >
              <img
                style={{ height: "30px" }}
                src={work1}
                loading="lazy"
                alt="Step 1"
                className="step-icon"
              />
              <div
                style={{ fontSize: isXs ? "24px" : "20px", fontWeight: "600" }}
                className="step-heading"
              >
                {t('aboutUs.pill_button_1')}
              </div>
            </div>

            <div
              data-aos="fade-up"
              style={{
                borderRadius: "60px",
                width: isXs ? "370px" : "auto",
                gap: "10px",
                marginLeft: isXs ? "40px" : "0px",
                marginBottom: "40px",
                alignItems: "center",
                padding: isXs ? "20px 44px 20px 32px" : "20px 30px",
                display: "flex",
                position: "relative",
                boxShadow: "4px 0 15px rgba(0, 0, 0, 0.1)",
              }}
            >
              {" "}
              <img
                style={{ height: "30px" }}
                src={work2}
                loading="lazy"
                alt="Step 1"
                className="step-icon"
              />
              <div
                style={{ fontSize: isXs ? "24px" : "20px", fontWeight: "600" }}
                className="step-heading"
              >
                {t('aboutUs.pill_button_2')}
              </div>
            </div>

            <div
              data-aos="fade-up"
              style={{
                borderRadius: "60px",
                alignItems: "center",
                marginLeft: isXs ? "240px" : "0px",
                gap: "10px",
                marginBottom: "40px",
                padding: isXs ? "20px 44px 20px 32px" : "20px 30px",
                display: "flex",
                width: isXs ? "370px" : "auto",
                position: "relative",
                boxShadow: "4px 0 15px rgba(0, 0, 0, 0.1)",
              }}
            >
              {" "}
              <img
                style={{ height: "30px" }}
                src={work3}
                loading="lazy"
                alt="Step 1"
                className="step-icon"
              />
              <div
                style={{ fontSize: isXs ? "24px" : "20px", fontWeight: "600" }}
                className="step-heading"
              >
                {t('aboutUs.pill_button_3')}
              </div>
            </div>

            <div
              data-aos="fade-up"
              style={{
                borderRadius: "60px",
                gap: "10px",
                alignItems: "center",
                marginLeft: isXs ? "40px" : "",
                marginBottom: "40px",
                padding: isXs ? "20px 44px 20px 32px" : "20px 30px",
                display: "flex",
                width: isXs ? "370px" : "auto",
                position: "relative",
                boxShadow: "4px 0 15px rgba(0, 0, 0, 0.1)",
              }}
            >
              {" "}
              <img
                style={{ height: "30px" }}
                src={work4}
                loading="lazy"
                alt="Step 1"
                className="step-icon"
              />
              <div
                style={{ fontSize: isXs ? "24px" : "20px", fontWeight: "600" }}
                className="step-heading"
              >
                {t('aboutUs.pill_button_4')}
              </div>
            </div>
          </div>
        </div>
      </div>

      <EnouthTalk />
      <Footer />
    </>
  );
}

export default AboutUs;
